import i18n from "i18next";
import LoadFromBackend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

const lng = window.wpml_language_codes.current_lang;

i18n
    .use(initReactI18next)
    .use(LanguageDetector)
    .use(LoadFromBackend)
    .init({
        lng: lng,
        backend: {
            loadPath: "/wp-json/translations/{{lng}}",

            parse: (data) => {
                data = JSON.parse(data);
                return data.strings;
            },
        },
        fallbackLng: "en",

        saveMissing: false,

        keySeparator: false,
        nsSeparator: false,

        interpolation: {
            escapeValue: false,
        },
        cache: {enable: false}
    });

export default i18n;